import classNames from 'classnames';
import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface PrimerAssemblyTabProps {
  isGoldenGate: boolean;
  showPrintableSummary: boolean;
  showBinding: boolean;
  showHomology: boolean;
  finalized: boolean;
}

function PrimerAssemblyTab({
  isGoldenGate,
  showPrintableSummary,
  showBinding,
  showHomology,
  finalized,
}: PrimerAssemblyTabProps): JSX.Element {
  return (
    <form
      className={classNames({'printable-summary': showPrintableSummary}, 'buffer-content-container-fluid')}
    >
      <div className="assembly-preview-mount" />
      <fieldset>
        <legend>Assembly Primers</legend>
        <div className="row primer-assembly-primers">
          <div className="col col-md-12">
            {showPrintableSummary && isGoldenGate && (
              <p>
                Recognition site in <span className="primer-base-recognition-site">bold</span>. Sticky end{' '}
                <span className="primer-base-sticky-end">underlined</span>. Bases that bind to parent in{' '}
                <span className="primer-base-match">italics</span>.
              </p>
            )}
            <table className="table table-condensed">
              <thead>
                <tr>
                  <th className="primer-name">Primer</th>
                  {showPrintableSummary && <th>Bases</th>}
                  <th className="text-center">
                    T<sub>m</sub>
                    <sup>whole</sup>
                    <br />
                    (&deg;C)
                  </th>
                  <th className="text-center">
                    T<sub>m</sub>
                    <sup>anneal</sup>
                    <br />
                    (&deg;C)
                  </th>
                  <th className="text-center">
                    T<sub>m</sub>
                    <sup>diff</sup>
                    <br />
                    (&deg;C)
                  </th>
                  {showBinding && (
                    <th className="text-center">
                      Binding
                      <br />
                      (bp)
                    </th>
                  )}
                  {showHomology && (
                    <th className="text-center">
                      Overhang
                      <br />
                      (bp)
                    </th>
                  )}
                  <th className="text-center">
                    Self &Delta;G
                    <br />
                    (kcal)
                  </th>
                  {!finalized && <th className="text-center">Mispriming</th>}
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </fieldset>
      <div className="js-sticky-ends-area hidden" />
      <div className="js-mismatches-area hidden">
        <fieldset>
          <legend>Mismatches Introduced</legend>
          <div className="row primer-assembly-mismatches">
            <div className="col col-md-12">
              <table className="table table-condensed table-hover">
                <thead>
                  <tr>
                    <th>Position</th>
                    <th>Parent</th>
                    <th>Original Base</th>
                    <th>New Base</th>
                  </tr>
                </thead>
                <tbody />
              </table>
              <p>No mismatches with parent sequences have been introduced.</p>
            </div>
          </div>
        </fieldset>
      </div>
      <div className="design-parameters-mount" />
    </form>
  );
}

export default makeDeprecatedJadeStyleTemplate<PrimerAssemblyTabProps>(PrimerAssemblyTab);
